import React, {FC} from 'react';

import {renderTimelineEventWithIconLinker} from './timelineEventsSection';
import {timelineLoadingItem} from './timelineSectionHelpers';

/*
 * Constants.
 */

const numberLoadingItems = 5;

/*
 * Component.
 */

export const TimelineEventsLoading: FC = () => (
  <>
    {Array.from({length: numberLoadingItems}, (_, index) =>
      renderTimelineEventWithIconLinker(timelineLoadingItem, index, index === numberLoadingItems - 1),
    )}
  </>
);
